// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-buttons .request {
  background-color: #4f71f0;
  color: #ffffff;
  border: 1px solid #4f71f0;
  height: 44px;
  padding-inline: 14px;
}

.vas-table .fund {
  background-color: transparent;
  border: 1px solid #0981fc;
  color: #0981fc;
  border-radius: 20px;
  padding-inline: 15px;
  text-align: center;
  padding-top: 5px;
  text-transform: uppercase;
}

.raise-charge .btn {
  background-color: #060d27;
  color: #ffffff;
  border: 1px solid #060d27;
  height: 44px;
  padding-inline: 14px;
}

.raise-charge .refresh {
  background-color: transparent;
  color: #060d27;
}

.raise-charge-modal .form-container {
  border: 1px solid #e6e6e6;
  width: 900px;
}

.raise-charge-modal input,
.raise-charge-modal .custom-select {
  width: 100%;
}

.raise-charge-modal .grouped-input {
  position: relative;
  font-size: 12px;
  font-weight: 100;
}

.raise-charge-modal .form-control {
  background-color: #ffffff;
  padding: 15px 0px 5px;
  box-shadow: none;
  /* border: 1px solid #097FFA; */
}

.raise-charge-modal form .error {
  text-align: left;
  font-size: 12px;
}

.raise-charge-modal .dropdown {
  text-align: start;
}

.raise-charge-modal label {
  position: absolute;
  font-size: 9px;
  left: 10px;
  top: 5px;
}

.raise-charge-modal .header {
  background-color: #f5f5f5;
  padding: 15px;
  text-align: start;
  text-transform: capitalize;
  border-bottom: 1px solid #e6e6e6;
}

.raise-charge-modal .form-footer,
.approval-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.raise-charge-modal .charge-action,
.approval-action {
  background-color: #f5f5f5;
  width: 50%;
  padding: 10px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.raise-charge-modal .charge-action .action-btn,
.approval-action .action-btn {
  border-radius: 4px;
  font-size: 12px;
  padding: 10px;
}

.raise-charge-modal .charge-action .cancel,
.approval-action .cancel {
  background-color: transparent;
  border: 1px solid #c1bcbc;
  color: #a0a0a0;
}

.raise-charge-modal .charge-action .create {
  background-color: #4d68c9;
  color: #ffffff;
  border: none;
}

.fund-approval-modal .modal-content {
  padding: 0;
  width: 920px;
}

.fund-approval-modal .header {
  background-color: #f5f5f5;
  padding: 15px;
  text-align: start;
  border-bottom: 1px solid #e6e6e6;
  border-start-start-radius: 20px;
  border-start-end-radius: 20px;
}

.fund-approval-modal .fund-approval-content {
  padding: 40px 60px;
}

.fund-approval-modal .funding-data {
  text-align: start;
  border-right: 1px solid #dedcdc;
}

.fund-approval-modal .funding-data h1,
.approval-details h1 {
  color: #a0a0a0;
  font-size: 12px;
  font-weight: 100;
  margin-bottom: 0;
}

.fund-approval-modal .funding-data p,
.approval-details p {
  color: #6a6a6a;
  font-weight: 500;
}

.fund-approval-modal .approval-details {
  text-align: start;
  padding-left: 40px;
}

.fund-approval-modal .approval-status {
  color: #ffffff;
  border-radius: 20px;
  width: fit-content;
  padding: 5px 20px;
  margin-bottom: 15px;
}

.fund-approval-modal .approved {
  background-color: #106745;
}

.fund-approval-modal .declined {
  background-color: #de0000;
}

.fund-approval-modal .approval-action .create {
  background-color: #106745;
  color: #ffffff;
  border: none;
}

.fund-approval-modal .approval-action .decline {
  background-color: #de0000;
  color: #ffffff;
  border: none;
}

.fund-approval-modal small {
  color: #de0000;
  background-color: #ffcaca;
  padding: 20px;
}

.table-actions .grouped-input {
  background-color: #ffffff;
  border: 1px solid #d2d2d2;
}

.table-actions .btn-refresh {
  height: 44px;
}

.return-btn {
  border: none;
  background-color: transparent;
  color: blue;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/fund-transactions/FundTransactions.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb","sourcesContent":[".table-buttons .request {\n  background-color: #4f71f0;\n  color: #ffffff;\n  border: 1px solid #4f71f0;\n  height: 44px;\n  padding-inline: 14px;\n}\n\n.vas-table .fund {\n  background-color: transparent;\n  border: 1px solid #0981fc;\n  color: #0981fc;\n  border-radius: 20px;\n  padding-inline: 15px;\n  text-align: center;\n  padding-top: 5px;\n  text-transform: uppercase;\n}\n\n.raise-charge .btn {\n  background-color: #060d27;\n  color: #ffffff;\n  border: 1px solid #060d27;\n  height: 44px;\n  padding-inline: 14px;\n}\n\n.raise-charge .refresh {\n  background-color: transparent;\n  color: #060d27;\n}\n\n.raise-charge-modal .form-container {\n  border: 1px solid #e6e6e6;\n  width: 900px;\n}\n\n.raise-charge-modal input,\n.raise-charge-modal .custom-select {\n  width: 100%;\n}\n\n.raise-charge-modal .grouped-input {\n  position: relative;\n  font-size: 12px;\n  font-weight: 100;\n}\n\n.raise-charge-modal .form-control {\n  background-color: #ffffff;\n  padding: 15px 0px 5px;\n  box-shadow: none;\n  /* border: 1px solid #097FFA; */\n}\n\n.raise-charge-modal form .error {\n  text-align: left;\n  font-size: 12px;\n}\n\n.raise-charge-modal .dropdown {\n  text-align: start;\n}\n\n.raise-charge-modal label {\n  position: absolute;\n  font-size: 9px;\n  left: 10px;\n  top: 5px;\n}\n\n.raise-charge-modal .header {\n  background-color: #f5f5f5;\n  padding: 15px;\n  text-align: start;\n  text-transform: capitalize;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.raise-charge-modal .form-footer,\n.approval-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.raise-charge-modal .charge-action,\n.approval-action {\n  background-color: #f5f5f5;\n  width: 50%;\n  padding: 10px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.raise-charge-modal .charge-action .action-btn,\n.approval-action .action-btn {\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 10px;\n}\n\n.raise-charge-modal .charge-action .cancel,\n.approval-action .cancel {\n  background-color: transparent;\n  border: 1px solid #c1bcbc;\n  color: #a0a0a0;\n}\n\n.raise-charge-modal .charge-action .create {\n  background-color: #4d68c9;\n  color: #ffffff;\n  border: none;\n}\n\n.fund-approval-modal .modal-content {\n  padding: 0;\n  width: 920px;\n}\n\n.fund-approval-modal .header {\n  background-color: #f5f5f5;\n  padding: 15px;\n  text-align: start;\n  border-bottom: 1px solid #e6e6e6;\n  border-start-start-radius: 20px;\n  border-start-end-radius: 20px;\n}\n\n.fund-approval-modal .fund-approval-content {\n  padding: 40px 60px;\n}\n\n.fund-approval-modal .funding-data {\n  text-align: start;\n  border-right: 1px solid #dedcdc;\n}\n\n.fund-approval-modal .funding-data h1,\n.approval-details h1 {\n  color: #a0a0a0;\n  font-size: 12px;\n  font-weight: 100;\n  margin-bottom: 0;\n}\n\n.fund-approval-modal .funding-data p,\n.approval-details p {\n  color: #6a6a6a;\n  font-weight: 500;\n}\n\n.fund-approval-modal .approval-details {\n  text-align: start;\n  padding-left: 40px;\n}\n\n.fund-approval-modal .approval-status {\n  color: #ffffff;\n  border-radius: 20px;\n  width: fit-content;\n  padding: 5px 20px;\n  margin-bottom: 15px;\n}\n\n.fund-approval-modal .approved {\n  background-color: #106745;\n}\n\n.fund-approval-modal .declined {\n  background-color: #de0000;\n}\n\n.fund-approval-modal .approval-action .create {\n  background-color: #106745;\n  color: #ffffff;\n  border: none;\n}\n\n.fund-approval-modal .approval-action .decline {\n  background-color: #de0000;\n  color: #ffffff;\n  border: none;\n}\n\n.fund-approval-modal small {\n  color: #de0000;\n  background-color: #ffcaca;\n  padding: 20px;\n}\n\n.table-actions .grouped-input {\n  background-color: #ffffff;\n  border: 1px solid #d2d2d2;\n}\n\n.table-actions .btn-refresh {\n  height: 44px;\n}\n\n.return-btn {\n  border: none;\n  background-color: transparent;\n  color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
